import _ from 'lodash';
import a from 'indefinite';
import pluralize from 'pluralize';

export function format(text, prefix, plural, determiner, mode) {
  let formattedText = text;

  if (plural) {
    formattedText = pluralize(formattedText, 2);
  } else {
    formattedText = pluralize(formattedText, 1);
  }

  let finalText = (prefix ? `${prefix} ` : '') + formattedText;
  if (mode === 'capitalize') {
    finalText = _.upperFirst(finalText);
  }
  if (determiner) {
    finalText = `${a(finalText, { articleOnly: true }).toLowerCase()} ${finalText}`;
  }

  return finalText;
}

export function escapeHTML(str) {
  if(!str) {
    return str;
  }

  return str.replace(/[&<>"']/g, function (match) {
      const escapeMap = {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
      };
      return escapeMap[match];
  });
}

export default {
  format,
  escapeHTML
};
